
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/popover_v2/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='popoverV2-arrow'></div>\n<div class='popoverV2-content'>\n  <div class='popoverV2-contentRegion'></div>\n</div>\n";
},"useData":true});
    }).call(this);
  